import { c as _c } from "react/compiler-runtime";
import { IcoMaximize16, IcoMinimize16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import { AnimatePresence, motion } from 'framer-motion';
import type { RefObject } from 'react';
import { Button } from '../..';
type EditModeProps = {
  textareaRef: RefObject<HTMLTextAreaElement | null>;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus: () => void;
  onBlur: () => void;
  disabled: boolean;
  placeholder?: string;
  hasError: boolean;
  currentHeight: number;
  shouldShowExpandButton: boolean;
  isExpanded: boolean;
  onToggleExpand: () => void;
};
const EditMode = t0 => {
  const $ = _c(31);
  const {
    textareaRef,
    value,
    onChange,
    onFocus,
    onBlur,
    disabled,
    placeholder,
    hasError,
    currentHeight,
    shouldShowExpandButton,
    isExpanded,
    onToggleExpand
  } = t0;
  const t1 = !hasError && !disabled;
  let t2;
  if ($[0] !== disabled || $[1] !== hasError || $[2] !== t1) {
    t2 = cx("relative flex w-full flex-col rounded-md border border-solid transition-colors overflow-hidden", {
      "border-tertiary hover:border-secondary focus-within:border-accent focus-within:shadow-[0_0_0_3px_rgba(var(--color-accent),0.1)]": t1,
      "border-error": hasError,
      "bg-secondary border-tertiary": disabled
    });
    $[0] = disabled;
    $[1] = hasError;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== currentHeight) {
    t3 = {
      height: currentHeight
    };
    $[4] = currentHeight;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== currentHeight) {
    t4 = {
      height: currentHeight,
      fontFamily: "\"DM Mono\", \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, Courier, monospace"
    };
    $[6] = currentHeight;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== disabled) {
    t5 = cx("w-full flex-1 min-h-0 px-3 py-2 pb-12 resize-none outline-none border-none", "text-body-2", "bg-primary text-primary placeholder:text-tertiary", {
      "bg-secondary opacity-60": disabled
    });
    $[8] = disabled;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== disabled || $[11] !== onBlur || $[12] !== onChange || $[13] !== onFocus || $[14] !== placeholder || $[15] !== t4 || $[16] !== t5 || $[17] !== textareaRef || $[18] !== value) {
    t6 = <motion.textarea ref={textareaRef} value={value} onChange={onChange} onFocus={onFocus} onBlur={onBlur} disabled={disabled} placeholder={placeholder} style={t4} className={t5} />;
    $[10] = disabled;
    $[11] = onBlur;
    $[12] = onChange;
    $[13] = onFocus;
    $[14] = placeholder;
    $[15] = t4;
    $[16] = t5;
    $[17] = textareaRef;
    $[18] = value;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== isExpanded || $[21] !== onToggleExpand || $[22] !== shouldShowExpandButton) {
    t7 = shouldShowExpandButton && <motion.div className="absolute bottom-0 left-0 right-0 flex w-full items-end justify-start p-1 bg-primary" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.15
    }}><Button prefixIcon={isExpanded ? IcoMinimize16 : IcoMaximize16} variant="secondary" size="compact" type="button" onClick={onToggleExpand} iconColor="primary" className="bg-transparent! border-0! shadow-none! text-primary! hover:bg-hover! hover:text-primary!">{isExpanded ? "Collapse" : "Expand"}</Button></motion.div>;
    $[20] = isExpanded;
    $[21] = onToggleExpand;
    $[22] = shouldShowExpandButton;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t7) {
    t8 = <AnimatePresence>{t7}</AnimatePresence>;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t2 || $[27] !== t3 || $[28] !== t6 || $[29] !== t8) {
    t9 = <div className={t2} style={t3}>{t6}{t8}</div>;
    $[26] = t2;
    $[27] = t3;
    $[28] = t6;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};
export default EditMode;